<template>
    <intake-form :view="view" :limit-months="limitMonths" :limit-events="limitEvents"></intake-form>
</template>
<script>
    import { ref, inject, onMounted, computed } from "vue";
    import intakeForm from "@/components/webComponents/widget/forms/intake-form.vue";

    export default {
        components: {
            intakeForm
        },
        props: {

        },
        setup(props, context) {

            const view = ref();
            const limitMonths = ref();
            const limitEvents = ref();

            return {
                view,
                limitMonths,
                limitEvents
            }
        }
    }
</script>
